export default __webpack_public_path__ + "static/media/banner_img.e0ed1a35.jpg";